module.exports = __webpack_public_path__ + "img/aiimage1.6b115204.jpg";